module.exports = __webpack_public_path__ + "media/images/checkmark-brand-checkbox-cb5102d7.png";